// @flow
import React, {Component} from 'react';
import {FormattedMessage} from 'react-intl';
import FilterGroup from '../FilterGroup/FilterGroup';
import {MoreOrLess} from '@homeaway/react-collapse';
import {displayFilterGroup, filterGroupFilters} from '../../utils/filters';

import './MoreFilters.less';
import type {Node} from 'react';
import type {Refinement} from '../FilterGroup/FilterGroup';

/* istanbul ignore next */
export type FilterGroupType = {
    name: string,
    key: string,
    filters: Refinement[]
};

export type Props = {
    filterGroups: FilterGroupType[],
    handleChecked: (event: SyntheticEvent<HTMLInputElement>) => void,
    numLines?: number,
    checked: string[],
    className?: string
};

const anyChecked = (filters: Refinement[], checked: string[]): boolean => {
    for (let i = 0; i < filters.length; i++) {
        if (checked.includes(filters[i].key)) {
            return true;
        }
    }
    return false;
};

type State = {
    filterChecked: string[]
};

export const renderFilterGroups = (
    filterChecked: string[],
    {filterGroups, className, handleChecked, checked, numLines = 6}: Props
): Node[] => {
    return filterGroups.map((filterGroup) => {
        const groupFilters = filterGroupFilters(filterGroup);
        const filterGroupId = filterGroup.key;
        return (
            <div
                className={className}
                key={filterGroupId}
                data-wdio={`MoreFilterGroup_${filterGroupId}`}
            >
                {displayFilterGroup(filterGroup) &&
                    groupFilters.length > numLines && (
                        <div
                            className="MoreFilters__filterGroup"
                            data-wdio={`MoreorLess_${filterGroupId}`}
                        >
                            <MoreOrLess
                                id={`MoreFilters--${filterGroupId}`}
                                expanderPosition="block"
                                lines={11}
                                lineHeight={28}
                                expanded={anyChecked(
                                    groupFilters,
                                    filterChecked
                                )}
                                moreText={
                                    <FormattedMessage
                                        id={'moreLabel'}
                                        defaultMessage={'More'}
                                        description={
                                            'Text for button to expand filter group'
                                        }
                                    />
                                }
                                lessText={
                                    <FormattedMessage
                                        id={'lessLabel'}
                                        defaultMessage={'Less'}
                                        description={
                                            'Text for button to contract filter group'
                                        }
                                    />
                                }
                            >
                                <FilterGroup
                                    handleChecked={handleChecked}
                                    groupName={filterGroup.name}
                                    filters={groupFilters}
                                    checked={checked}
                                />
                            </MoreOrLess>
                        </div>
                    )}
                {displayFilterGroup(filterGroup) &&
                    groupFilters.length <= numLines && (
                        <div className="MoreFilters__filterGroup">
                            <FilterGroup
                                handleChecked={handleChecked}
                                groupName={filterGroup.name}
                                filters={groupFilters}
                                checked={checked}
                            />
                        </div>
                    )}
            </div>
        );
    });
};

class MoreFilters extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            filterChecked: this.props.checked // we only want to set this at initial mount
        };
    }

    render() {
        const {filterChecked} = this.state;
        return renderFilterGroups(filterChecked, this.props);
    }
}

export default MoreFilters;
